<template>
<!-- 开票记录 -->
  <div class="invoice-recording">
    <ab-list-query :tabs='tabs' isActive='0' @handleTabs='handleTabs'>
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input   
                        placeholder="开票申请单"
                        v-model.trim="formSearch.number"
                        clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="4"> 
                    <el-select    placeholder="开票状态" v-model="formSearch.clientStatus" @change="searchForm" clearable>
                        <el-option
                            v-for="(option, idx) in options.clientStatusList"
                            :key="idx"
                            :label="option.desc"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4"> 
                    <el-select    placeholder="合同状态" v-model="formSearch.signStatus" @change="searchForm" clearable>
                        <el-option
                            v-for="(option, idx) in options.statusList"
                            :key="idx"
                            :label="option.desc"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" v-if="this.bizType && this.bizType.activeIndex == '01'"> 
                    <el-select    placeholder="发票类型" v-model="formSearch.bizType" @change="searchForm" clearable>
                        <el-option v-for="(option, idx) in bizTypeList" :key="idx" :label="option.desc" :value="option.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        class="searchBox"
                        startSrc="创建日期起"
                        endSrc="创建日期止"
                        v-model="formSearch.updateTimeArr"
                        @searchEvent="changeTimeRange"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm" :loading='load.btnLoading'>搜索</el-button>
                    <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
        </template>

        <template #toolbar>
            <el-button type="primary" :loading="load.btn2Loading" @click="exportFile">导出</el-button>
            <el-button :disabled="printDis" @click="printPdf">打印合同</el-button>

            <!-- <el-button :loading="load.btn3Loading" :disabled="multiSelected.length !== 1" @click="setUploadContract">上传合同</el-button> -->
            <ab-fileBtn
                multiple
                class="multiUpload"
                v-model:fileData="fileData"
                :mustId="true"
                @change="setUploadContract"
                text="上传合同"
                :disabled="multiSelected.length !== 1"
            ></ab-fileBtn>

            <el-button :disabled="isDel"  :loading="load.btn3Loading" @click="delRow">删除</el-button>
        </template>

        <template #table>
            <ab-table
                class="materialTable"
                ref="table"
                stripe
                showEdit
                showSelection
                selectionWidth="45"
                indexWidth="50"
                :widths="widen? 280 : 180"
                isFilter="operator"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="load.isloading"
                :handleSelectionChange='handleSelectionChange'
                @filterColumns="filterColumns"
            >
                <template #operator='scope'>
                    <el-button
                        v-if="scope.row.esignTaskId"
                        type="primary"
                        link
                        :loading="scope.row.loading"
                        @click="getFlowUrl(scope.row)"
                    >签署</el-button>

                    <el-button type="primary" link @click="handlerFileView(scope.row)" :disabled="!scope.row.isUploadClientRequire">附件</el-button>
                    <!-- <i class="dividingLine"></i>                     -->
                    <el-button style="margin-left: 10px" type="primary" link @click="invoice(scope.row)">详情</el-button>                    
                </template>

                <template #clientStatusDesc='scope'>
                    <div>
                        <span :class="getStatusClass(scope.row.clientStatusDesc)"></span>
                        {{ scope.row.clientStatusDesc }}
                    </div>
               </template>

               <template #signStatusDesc='scope'>
                    <div>
                        <span :class="getStatusClass(scope.row.signStatusDesc)"></span>
                        {{ scope.row.signStatusDesc }}
                    </div>
               </template>

               <template #taxRate='scope'>
                    {{scope.row.taxRate}}%                  
                </template>
            </ab-table>
            
        </template>

        <template #page>
            <ab-page
                :pageTotal="page.total" 
                :currentPage='page.currentPage' 
                :pageSize="page.pageSize" 
                :pageSizes="page.pageSizes"
                @searchForm="pageSearch"
            ></ab-page>
        </template>
    </ab-list-query>
    <ab-downloadFile :dialog="fileView"></ab-downloadFile>

    <ab-preview :preview="preview" @handleClose="searchForm">
      <template #button>
        <el-button @click="preview.show = false">关 闭</el-button>
      </template>
    </ab-preview>
  </div>
</template>

<script>
export default {
    name: 'invoice-history',
    data() {
        return {
            exceptOrStatus:{},//已完成或者未完成参数
            //状态汇总
            load:{
                btnLoading:false,
                isloading:false,
                btn2Loading:false,
                btn3Loading:false,
                btn4Loading:false
            },
            widen: false,
            options:{},//申请状态选择项
            isAddLoading:false,
            formSearch:{},
            tabs: [
                {name: '全部', value: '', state: '0'},
                {name: '进行中', value: '', state: '1'},
                {name: '已完成', value: '', state: '2'},
            ],
            columns: [
                {
                    props: 'number',
                    labels: '开票申请单',
                    widths: 100,
                },
                {
                    props: 'createTime',
                    labels: '创建时间',
                    widths: 130
                },
                {
                    props: 'clientStatusDesc',
                    labels: '开票状态',
                    widths: 80,    
                    slot:'slot'               
                },
                {
                    props: 'signStatusDesc',
                    labels: '合同状态',
                    widths: 80,
                    slot:'slot'               
                },
                {
                    props: 'custOrderNos',
                    labels: '订单编号',
                    widths: 130
                },
                {
                    props: 'invoiceTaxDesc',
                    labels: '发票类型',
                    widths: 120,              
                },
            
                {
                    props: 'invoiceAmount',
                    labels: '开票金额',
                    widths: 90,
                    type:'money',
                    align:'right'
                },
                {
                    props: 'invoiceCurrencyDesc',
                    labels: '币别',
                    widths: 70,
                },
                {
                    props: 'taxRate',
                    labels: '税率',
                    widths: 60,
                    slot:'slot'
                },
                {
                    props: 'invoiceNumber',
                    labels: '发票号',
                    widths: 100,
                },
                {
                    props: 'invoiceCount',
                    labels: '发票份数',
                    widths: 80,
                },
                {
                    props: 'expressNumber',
                    labels: '快递单号',
                    widths: 80,
                },
            ],
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            // 勾选行
            multiSelected: [],
            //进出口判断
            bizTypeList:[],
            entrustType:'',
            bizType:{},
            importTypeList: ['01', '02', '11'],
            exportTypeList: ['03', '04', '06'],
            // 附件
            fileData: {
                sourceBillId: "",
                attachType: "010",
                sourceBillType: "DrawInvoice",
                sourceBillNumber: "",
                coreBillIds: "",
                coreBillNumbers: ""
            },
            fileView: {
                title:'附件',
                sourceBillType: "DrawInvoice",
                sourceBillId: "",
                sourceBillNumber: "",
                show: false,
                items: [
                    { title: "销售合同", attachType: "010" },
                    { title: "发票", attachType: "020" }
                ]
            },
            preview: {
                show: false,
                isView: false,
                isFooter: true,
                fileUrl: "",
            },
        }
    },
    computed:{
        isDel() {
            let flag = false;
            if (!this.multiSelected.length) {
                return true;
            } else {
                this.multiSelected.forEach(ele => {
                    console.log(ele.clientStatus !== "01-1",ele.clientStatus);
                if (ele.clientStatus !== "01-1") {
                    flag = true;
                }
                });
            }
            return flag;
        },
        printDis() {
            if (!this.multiSelected.length) {
                return true;
            }
            let first = this.multiSelected[0];
            for (let row of this.multiSelected) {
                if (!["合作进口"].includes(row.bizTypeDesc)) {
                return true;
                }
                if (
                    first.principalId !== row.principalId ||
                    first.trusteeId !== row.trusteeId ||
                    first.bizType !== row.bizType ||
                    first.invoiceType !== row.invoiceType
                ) {
                return true;
                }
            }
            return false;
        },
        bizTypeNow: {
            get() {
                return (
                    this.$store.state.bizTypeNow 
                )
            }
        },
        activeIndexMenu: {
            get() {
                return (
                    this.$store.state.activeIndexMenu 
                )
            },
        },
    },
    methods:{
        //日期
        changeTimeRange(obj){
            this.formSearch.updateTimeArr=obj
            if (obj) {
                this.formSearch.startDate = obj[0];
                this.formSearch.endDate = obj[1];
            } else {
                this.formSearch.startDate = "";
                this.formSearch.endDate = "";
            }
            this.searchForm()
        },
        filterColumns(val){
            this.columns=val
        },
        pageSearch(val){
            console.log(val);
            this.page.pageSize=val.pageSize
            this.page.currentPage=val.currentPage
            this.getDataList()
        },
        getStatusClass(val){
            let cls
            switch (val) {
                case "待审核":
                    cls = "status-13227A";
                break;
                case "已审核":
                    cls = "status-1165D4";
                break;
                case "已申请":
                    cls = "status-0AB2A8";
                break;
                case "已开票":
                    cls = "status-8C10E2";
                break;
                case "已寄出":
                    cls = "status-FF8400";
                break;
                case "已作废":
                    cls = "status-B1B1B1";
                break;
                case "已退回":
                    cls = "status-E21010";
                break;
                case "待签章":
                    cls = "status-13227A";
                break;
                case "已签章":
                    cls = "status-0AB2A8";
                break;
                case "待签署":
                    cls = "status-13227A";
                break;
                case "已签署":
                    cls = "status-0AB2A8";
                break;
            }
            return cls
        },
        //详情
        invoice(row){
            this.$router.push({
                path:'/invoice-detail',
                query:{id: row.id}
            })
        },
        //菜单栏切换
        handleTabs(idx){
            if(idx==1){
                this.exceptOrStatus={exceptStatusList: ['06'] }
            }else if(idx==2){
                this.exceptOrStatus={statusList: ['06']}
            }else{
                this.exceptOrStatus={}
            }
            this.getDataList()
        },
        //搜索
        searchForm(){
            this.load.btnLoading=true
            this.getDataList()
        },
        //获取数据
        getDataList() {
            console.log(this.activeIndexMenu)
            this.bizType = this.$utils.getSessionStorage('bizType') || {}
            //状态改变
            this.load.isloading = true
            let bizTypeList = this.bizType && this.bizType.activeIndex == '02' ? this.exportTypeList : this.importTypeList
            let data = {...this.formSearch,bizTypeList,...this.exceptOrStatus,...this.formSearch} 
            let params={
                data:data,
                pageNum: this.page.currentPage, 
                pageSize: this.page.pageSize
            }
            this.$post("/fms/client/drawInvoice/pageList",params).then(({ data }) => {
                if (data && data.code === "C0000") {
                    data.result.list.forEach(row => {
                        row.loading = false
                        if(row.esignTaskId){
                            this.widen = true
                        }
                    })
                    this.tableData = data.result.list;
                    this.page.total = data.result.total;
                    if(data.extra){}
                } else {
                    this.tableData = [];
                    this.pages.total = 0;
                }
            // this.countWaitSign();
            }).finally(() => {
                this.load.isloading=false
                this.load.btnLoading=false
            });           
        },
        //未读数据
        judgment(){
            this.tabs.forEach((item)=>{
                if(item.state=1){

                }else if(item.state=2){

                }
            })
        },
        //选择项数据
        getSelectList() {
            this.$get("/fms/client/drawInvoice/getDDL").then(({ data }) => {
                if (data && data.code === "C0000") {
                    data.result.clientStatusList = data.result.clientStatusList.filter(e => e.desc !== "");
                    data.result.statusList = data.result.statusList.filter( e => e.desc !== "");
                    this.options = data.result;
                } else {
                    this.options = {};
                }
            });
        },
        // 导出
        exportFile() {
            this.load.btn2Loading=true
            let excelField = this.columns.map(e => e.props);
            if(this.bizTypeNow == '01') {
                this.formSearch.bizTypeList = ['01', '02', '11']
            }else if(this.bizTypeNow == '02'){
                this.formSearch.bizTypeList = ['03', '04', '06']
            }
            let params = Object.assign(
                {},
                {
                    data: this.formSearch,
                    excelField: excelField,
                    colTitleMapList: this.columns
                }
            );
            this.$post("/fms/client/drawInvoice/deriveList",params).then(({ data }) => {
                if (data && data.code === "C0000") {
                this.windowOpenFile(data.message);
                }
            }).finally(() => {
                this.load.btn2Loading=false
            }); 
        },
         // 创建隐藏的可下载链接
        windowOpenFile(url) {
            // 创建隐藏的可下载链接
            var eleLink = document.createElement("a");
            eleLink.download = "";
            eleLink.target = "_blank";
            eleLink.style.display = "none";
            // 字符内容转变成blob地址
            eleLink.href = url;
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);
        },
        //列表选择项
        handleSelectionChange(array){
            this.multiSelected = array;
            // 附件
            if (array.length === 1) {
                this.fileData.sourceBillId = array[0].id;
                this.fileData.sourceBillNumber = array[0].number;
                this.fileData.coreBillIds = array[0].coreBillIds;
                this.fileData.coreBillNumbers = array[0].coreBillNumber? array[0].coreBillNumber.replace(/\//g,",") : '';
            } else {
                this.fileData.sourceBillId = "";
                this.fileData.sourceBillNumber = "";
                this.fileData.coreBillIds = "";
                this.fileData.coreBillNumbers = "";
            }
        },
        //上传合同
        setUploadContract(){
            this.$post("/fms/drawInvoice/setUploadContract?id=" + this.multiSelected[0].id).then(({ data }) => {
                if (data && data.code === "C0000") {
                    this.getDataList()
                }
            });
        },
        //删除
        delRow() {
            this.$confirm('确认删除吗?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

            let ids = []
            this.multiSelected.forEach(ele=>{
                ids.push(ele.id)
            })
            let data = { ids };
            this.$post("/fms/client/drawInvoice/delBatch", data).then(({ data }) => {
                if (data && data.code === "C0000") {
                this.$message.success(data.message)
                this.getDataList()
                } else {
                this.$message.error(data.message)
                }
            });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 打印销售合同pdf
        printPdf() {
            this.load.btn4Loading=true
            this.$post("/fms/drawInvoice/printSalesContractPdf",{ ids: this.multiSelected.map(row => row.id)}).then(({ data }) => {
                if (data && data.code === "C0000") {
                    this.$message({
                        type: 'success',
                        message: data.message
                    })
                    // this.windowOpenFile(data.result);
                }
            }).finally(() => {
                this.load.btn4Loading=false
            }); 
        },
        //附件展示
        handlerFileView(row) {
            this.fileView.sourceBillId = row.id;
            this.fileView.sourceBillNumber = row.coreBillNumber;
            this.fileView.show = true;
        },
        getFlowUrl(row) {
            row.loading = true
            this.$get('/sys/esignTask/getFlowUrl', {
                id: row.esignTaskId,
                urlType: 0,
            }).then(({ data }) => {
                if (data.code === "C0000") {
                    this.preview.isView = true;
                    this.preview.fileTitle = row.number;
                    this.preview.fileUrl = data.result;
                    this.preview.show = true;
                }
            }).finally(() => {
                row.loading = false
            })
        }
    },
    created(){
        let importTypeList = [
            {value: "01", desc: "13% 增值税专用发票"},//合作进口
            {value: "02", desc: "海关税票+6% 服务费发票"},//代理进口
        ]
        let exportTypeList = [
            {value: "04", desc: "代理出口"}
        ]
        /* let userInfo = this.$utils.getSessionStorage('userInfo') || {}
        if (userInfo.clientImportRole) {
            this.bizTypeList = importTypeList
            this.entrustType = 'import'
        } else if (userInfo.clientExportRole) {
            this.bizTypeList = exportTypeList
            this.entrustType = 'export'
        } */

        let bizTypes = this.$utils.getSessionStorage('bizType') || {}
        this.bizType = bizTypes
        if (bizTypes.activeIndex == '01') {
            this.entrustType = 'import'
            this.bizTypeList = importTypeList
        } else if (bizTypes.activeIndex == '02') {
            this.bizTypeList = exportTypeList
            this.entrustType = 'export'
        }
        this.getSelectList()
    },
    activated () {
        this.searchForm()
    }
}
</script>

<style lang='scss'>
 .invoice-recording{
    .file-upload-btn{
        display: inline-block;
        margin: 0 12px;
    }
 }
</style>